import {Component} from 'react';
import {connect} from 'react-redux';

import {airportActive, airportInactive} from '../../../actionCreators';

import Airport from './Airport';

class Wrapper extends Component {

    constructor(props) {
        super(props);

        this.timeStamp = null;

        this.handleClick = this.handleClick.bind(this);
        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
    }

    render() {
        return (
            <Airport
                {...this.props}
                onClick={this.handleClick}
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.onMouseLeave}
            />
        );
    }

    handleMouseEnter(event) {
        const {icao, onActive} = this.props;

        /* Save the events timestamp to distinguish between
           this event and on click. See below. */
        this.timeStamp = event.timeStamp;

        return onActive(icao);
    }

    handleClick(event) {
        event.preventDefault();
        event.stopPropagation();

        /* Workaround for Android to distinguish the first click
           (hover) and the second click (scroll to airport). */
        if (this.timeStamp === event.timeStamp) return;

        const {icao, onClick} = this.props;

        return onClick(icao);
    }

    onMouseLeave() {
        const {icao, onInactive} = this.props;

        this.timeStamp = null;

        return onInactive(icao);
    }

}

const mapStateToProps = ({active}, {icao}) => ({active: active === icao});

const mapDispatchToProps = dispatch => ({
    onActive: icao => dispatch(airportActive(icao)),
    onInactive: icao => dispatch(airportInactive(icao)),
    onClick: icao => dispatch(airportActive(icao, true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Wrapper);
